import { DataBean } from "../DataBean";

export class Updatedepreciation extends DataBean {


    public async updateFixedAssetItemDepreciation(idDepreciation:any,value:any,employeeID:any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "java.util.List_updateFixedAssetItemDepreciation_Number_Number_Number", [idDepreciation,value,employeeID]);
    }
    public async updateDepreciationTimeForFixedAssetItemDepreciation(idDepreciation:any,value:any,employeeID:any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "java.util.List_updateDepreciationTimeForFixedAssetItemDepreciation_Number_Number_Number", [idDepreciation,value,employeeID]);
    }
    public async updateLiveTimeForFixedAssetItemDepreciation(idDepreciation:any,value:any,employeeID:any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "java.util.List_updateLiveTimeForFixedAssetItemDepreciation_Number_Number_Number", [idDepreciation,value,employeeID]);
    }
}